<template>
	<div class="menu-list">
		<el-row v-bind:class="(qty > 0 && menu.imageUrl == 'restaurant/add_menu_edit_no_image.png') ? 'pb-0' : '' ">
			<el-col :span="7" v-if="menu.imageUrl != 'restaurant/add_menu_edit_no_image.png'" >
				<div class="menulist-img-content flex">
					<el-image 
						class="menulist-image"
						:src="'https://images.foodstory.co/'+menu.imageUrl"
						fit="cover"
					/>
				</div>
			</el-col>
			<el-col :span="menu.imageUrl != 'restaurant/add_menu_edit_no_image.png' ? 11 : 18">
				<div class="menu-detail">
					<div class="menu-topic text-heading3--med">{{menu.name}}</div>
					<div 
						class="text-subtitle"
						:class="(menu.description == '') ? 'menu-description' : 'menu-description fs-h-25'">
						{{ menu.description }}
					</div>
				</div>
			</el-col>
			<el-col :span="6" class="text-right">
				<span class="menu-price text-heading3--med">{{ menu.price | priceFormat(0,$store.getters.currency) }}</span>
			</el-col>
		</el-row>

		<div 
			class="quantity-order-menu text-heading3--bold" 
			v-if="qty > 0 && menu.imageUrl != 'restaurant/add_menu_edit_no_image.png'">
			{{qty}}
		</div>
		<div class="width-100p text-right m-b-20 pb-4"  v-else-if="qty > 0">
			<div class="quantity-order-menu text-heading3--bold no-img">{{qty}}</div>
		</div>
	</div>
</template>
<script>
import Mixins from '@/utils/mixins'
export default {
    name: 'MenuItem',
    props: {
        menu:{
            default: {}
        }
    },
    mixins: [Mixins],
    computed:{
        qty () {
            let qty = 0
            let amountCart = this.$store.getters.AmountCart
            amountCart = amountCart.filter(item => item.id == this.menu.id)
            amountCart = amountCart.forEach(item => {
                qty += item.qty
            })
            return qty
        }
    }
}
</script>
<style>
    .image-slot{
        width: 80px;
        height: 80px;
        background-color:  darkgrey;
    }
</style>


// WEBPACK FOOTER //
// src/components/menu/MenuItem.vue